import { Component, OnInit, AfterViewChecked, AfterViewInit, Input, ViewChild } from '@angular/core';
import { DataService } from '../data.service';
import { Trasllat } from '../lib/model/trasllat';
import { MatStepper } from '@angular/material';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-pagament',
  templateUrl: './pagament.component.html',
  styleUrls: ['./pagament.component.css']
})
export class PagamentComponent implements OnInit,  AfterViewChecked  {

  @ViewChild('formulari') formulari: NgForm;
  @Input() stepper: MatStepper;

  trasllat: Trasllat;
  stepPerformed = false;

  constructor(
      private dataService: DataService,
  ) {
    this.trasllat = dataService.trasllat;
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
    this.trasllat = this.dataService.trasllat;
  }

  public async continua() {
    if (this.trasllat.estat === 64) {
      window.location.href = this.trasllat.urlCistellaPagamentInscripcio;
    } else {
      this.stepper.next();
      if (!this.stepPerformed) {
        this.dataService.maxStep++;
        this.stepPerformed = true;
      }
    }
  }

  public isValid(): boolean {
    try {
      if (this.formulari == null) {
        return false;
      }
      if (this.formulari.form == null) {
        return false;
      }
      if (this.formulari.form.invalid) {
        return false;
      }
    } catch (ex) {
      console.log('Error a isValid()');
      console.log(ex.Message);
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/pagament/pagament.component.ts